import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Locales as LocalesGenerator } from '@core/locales';
import DeleteBulkResourcesPrompt from './DeleteBulkResourcesPrompt.json' with {
    type: 'json'
};
import DeleteSingleResourcePrompt from './DeleteSingleResourcePrompt.json' with {
    type: 'json'
};
import EditConfirmationPrompt from './EditConfirmationPrompt.json' with {
    type: 'json'
};
import FrequencySelector from './FrequencySelector.json' with {
    type: 'json'
};
import PeriodPreset from './PeriodPreset.json' with {
    type: 'json'
};
import ProjectsList from './ProjectsList.json' with {
    type: 'json'
};
import StatusToken from './StatusToken.json' with {
    type: 'json'
};
import ValueWithLabel from './ValueWithLabel.json' with {
    type: 'json'
};
var req = {
    'strings/FrequencySelector': FrequencySelector,
    'strings/PeriodPreset': PeriodPreset,
    'strings/StatusToken': StatusToken,
    'strings/ValueWithLabel': ValueWithLabel,
    DeleteBulkResourcesPrompt: DeleteBulkResourcesPrompt,
    DeleteSingleResourcePrompt: DeleteSingleResourcePrompt,
    ProjectsList: ProjectsList,
    EditConfirmationPrompt: EditConfirmationPrompt
};
var translations = {};
Object.keys(req).forEach(function(key) {
    var parts = key.split('/');
    var roots = parts.splice(0, parts.length - 2);
    var map = translations;
    roots.forEach(function(root) {
        if (!map[root]) {
            map = _object_spread_props(_object_spread({}, map), _define_property({}, root, {}));
        }
        map = map[root];
    });
    translations = _object_spread({}, map, req[key]);
});
var enDictionary = {
    locale: 'en',
    translations: translations
};
export var Locales = new LocalesGenerator({
    dictionaries: [
        enDictionary
    ],
    defaultLocale: 'en'
});

//# sourceMappingURL=Locales.js.map